<template>
<div>
    <div>
        <div v-for="associate in associateList" class="control-label text-label">
            <siteEvaluation :head="associate" :culturalResource="culturalResource" :onEvaluationSave="loadData" :isQaqc="isQaqc" :isConsultantSubmitted="isSubmitted"
            :isAgencySubmitted="isAgencySubmitted" :hasAgencyAccess="hasAgencyAccess" :hasShpoAccess="hasShpoAccess" :isConditionReport="isConditionReport" :isInternalReview="isInternalReview"
            :isNormalization="isNormalization" ref="siteEval"></siteEvaluation>
        </div>
    </div>
    <div v-if="isSegment">
        <segmentEvaluation ref="segmentEval" :segmentHead="segmentHead" :segHeadEval="segHeadEval" :culturalResource="culturalResource" :isQaqc="isQaqc"
        :isConsultantSubmitted="isSubmitted" :isAgencySubmitted="isAgencySubmitted" :hasAgencyAccess="hasAgencyAccess" :hasShpoAccess="hasShpoAccess" :isConditionReport="isConditionReport"
        :isInternalReview="isInternalReview" :onEvaluationSave="loadData" :isNormalization="isNormalization">
        </segmentEvaluation>
    </div>
    <div class="panel panel-offset">
        <div class="panel-heading green-bg">
            <h3 class="panel-title">Form Submission</h3>
        </div>
        <div class="panel-body">
            <workflowHistory :workflowInstanceStatusDtoList="workflowInstanceStatusDtoList"></workflowHistory>
            <!-- Sumbmit site form workflow -->
            <workflowSubmit ref="workflowSubmit" :workflowStatusDtoNextList="nextWorkflowStatusList"
            :workflowInstanceId="workflowInstance.workflowInstanceId" v-on:workflowSubmitOnSubmitSuccess="workflowSubmitOnSubmitSuccess"></workflowSubmit>
            <user-assignment ref="userAssignment" :parentId="crrId" :workflowId="crrWorkflowId"></user-assignment>
            <!-- <div class="form-group">
                <div class="col-md-6 col-md-offset-2">
                    <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                </div>
            </div>
            <button v-if="currentWorkflowStatusCheck" class="btn btn-primary" v-on:click="workflowSubmit">Complete Form</button> -->
        </div>
    </div>
</div>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import workflowService from '@/services/workflowService'
import culturalResourceService from '@/services/culturalResourceService'
import culturalResourceRecordingService from '@/services/culturalResourceRecordingService'
import culturalResourceGroupService from '@/services/culturalResourceGroupService'
import evaluationService from '@/services/siteForm/evaluationService'
import userAssignment from '@/components/UserAssignment.vue'

import workflowInstance from '@/components/workflow/WorkflowInstance.vue'
import workflowHistory from '@/components/workflow/WorkflowHistory.vue'
import workflowSubmit from '@/components/workflow/workflowSubmit.vue'
import siteEvaluation from '@/components/siteForm/siteEvaluation.vue'
import segmentEvaluation from '@/components/siteForm/segmentEvaluation.vue'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'

export default {
    name: 'siteFormEligibility',
    components: {
        validationResultDisplay,
        workflowHistory,
        workflowInstance,
        workflowSubmit,
        siteEvaluation,
        segmentEvaluation,
        userAssignment
    },
    props: {
        culturalResourceRecording: {},
        culturalResource: {},
        isConditionReport: { default: false },
        isInternalReview: { default: false },
        hasAgencyAccess: { default: false },
        hasShpoAccess: { default: false },
        isNormalization: { default: false }
    },
    data: function () {
        return {
            isLoading: false,
            isDebug: true,
            crrId: this.$route.params.culturalResourceRecordingId,
            crrWorkflowId: workflowService.WorkflowEnum.CulturalResourceRecording,
            workflowInstance: {},
            currentWorkflowStatus: {},
            nextWorkflowStatusList: [],
            workflowInstanceStatusDtoList: null,
            validationResult: [],
            associateList: [],
            onWorkflowLoadedEventName: 'workflowLoaded',
            onWorkflowSubmitSuccessEventName: 'workflowOnSubmitSuccess',
            segmentHead: null,
            segHeadEval: null
        }
    },
    mounted () {
        this.log('Mounted')
    },
    computed: {
        currentWorkflowStatusCheck: function () {
            //checks if currentWorkflow status is "PendingDataEntry"
            var checkStatusList = [culturalResourceRecordingService.WorkflowStatusEnum.PendingDataEntry]
            return (checkStatusList.includes(this.currentWorkflowStatus ? this.currentWorkflowStatus.workflowStatusId : 0))
        },
        isQaqc: function () {
            return this.currentWorkflowStatus ? (this.currentWorkflowStatus.workflowStatusId === culturalResourceRecordingService.WorkflowStatusEnum.Concurrence) : false
        },
        isSubmitted: function () {
            return this.currentWorkflowStatus ? (this.currentWorkflowStatus.workflowStatusId !== culturalResourceRecordingService.WorkflowStatusEnum.PendingDataEntry &&
                this.currentWorkflowStatus.workflowStatusId !== culturalResourceRecordingService.WorkflowStatusEnum.PendingInvestigationSubmit) : false
        },
        isAgencySubmitted: function () {
            return this.currentWorkflowStatus ? (this.currentWorkflowStatus.workflowStatusId > culturalResourceRecordingService.WorkflowStatusEnum.PendingAgencyApproval) : false
        },
        isSegment: function () {
            return this.culturalResource && this.culturalResource.segment > 0
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Eligibility', message)
        },
        loadHeadEval (culturalResourceHeadId) {
            this.log('Finding Current Eligibility of ' + culturalResourceHeadId)
            return evaluationService.currentEligibility(this.$http, culturalResourceHeadId).then(evalResult => {
                var currentEval = evalResult.data
                //if the head is currently eligible, add it to the list
                if (currentEval && currentEval.eligibilityId === evaluationService.EligibilityEnum.Eligible) {
                    this.log(`This head ${culturalResourceHeadId} is eligible`)
                    culturalResourceService.get(this.$http, culturalResourceHeadId).then(crHeadResult => {
                        this.log(`pushing CR onto list`)
                        var headCR = crHeadResult.data
                        headCR.currentEval = currentEval
                        this.associateList.push(headCR)
                        return crHeadResult
                    })
                } else {
                    this.log(`CR ${currentEval} not eligible: ${currentEval.eligibilityId} vs ${evaluationService.EligibilityEnum.Eligible}`)
                    return evalResult
                }
            })
        },
        loadAssociates () {
            //Anything that is not a segment gets a normal evalulation
            this.log('Loading associate')
            if (!this.isSegment) {
                this.log('Adding itself because its not a segment')
                this.associateList.push(this.culturalResource)
            } else {
                //load segment head and segmentEval if this is a segment
                culturalResourceService.getSegmentHead(this.$http, this.culturalResource.culturalResourceId).then(segHeadResult => {
                    if (segHeadResult.data) {
                        this.segmentHead = segHeadResult.data
                        //load the segment head current eval
                        evaluationService.currentEligibility(this.$http, this.segmentHead.culturalResourceId).then(segHeadEvalResult => {
                            if (segHeadEvalResult.data) {
                                this.segHeadEval = segHeadEvalResult.data
                            }
                            this.$refs.segmentEval.loadData()
                        })
                    }
                })
            }
            if (!this.isSegment && this.culturalResource.grouping === 'Group Member') {
                //Go get all the heads for this CR
                //deprecated, no need to load group head, besides groupItem.culturalResourceHeadId doesn't exist
                this.log(`finding all groups for CR ${this.culturalResourceRecording.culturalResourceId}`)
                var searchDto =
                    {
                        culturalResourceMemberId: this.culturalResourceRecording.culturalResourceId,
                        associateSearch: true
                    }
                culturalResourceGroupService.search(this.$http, searchDto).then(groupResult => {
                    this.log(`Found ${groupResult.data.length} members to go look at`)
                    var promiseList = []
                    groupResult.data.forEach(groupItem => {
                        // Not all groups have a head. Only look for the eval if a head exists.
                        if (groupItem.groupMemberTypeId === 1) {
                            promiseList.push(this.loadHeadEval(groupItem.culturalResourceMemberId))
                        }
                    })
                    Promise.all(promiseList).then(headEvalResult => {
                        this.log('Done determining head eligibilities')
                        return headEvalResult
                    })
                })
                return Promise.resolve(1)
            } else {
                this.log(`CR ${this.culturalResourceRecording.culturalResourceId} is not a group member, grouping: ${this.culturalResource.grouping}`)
                return Promise.resolve(1)
            }
        },
        loadData () {
            this.associateList = []
            this.isLoading = true
            var crrId = this.$route.params.culturalResourceRecordingId

            this.log(`Loading data from ${crrId}`)
            if (!this.culturalResource || !this.culturalResourceRecording) {
                this.log('Nothing to load yet')
                return Promise.resolve(1)
            }
            this.associatesList = []
            return Promise.all([this.loadAssociates(crrId), this.loadWorkflow(crrId)]).then(response => {
                this.$refs.userAssignment.loadData()
                this.isLoading = false
                this.log('Done loading data, associatesList length' + this.associatesList.length)
                return response
            })
        },
        loadWorkflow (crrId) {
            var handle = this
            this.log('Loading Workflow')
            return workflowService.getWorkflowInstanceDto(this.$http, workflowService.WorkflowEnum.CulturalResourceRecording, crrId).then(response => {
                this.workflowInstance = response.data
                Promise.all([handle.loadHistory(), handle.loadWorkflowStatus(crrId), handle.loadNextWorkFlowStatusDto()]).then(response2 => {
                    return response2
                })
            })
        },
        loadNextWorkFlowStatusDto (validationResult) {
            this.nextWorkflowStatusList = null
            var handle = this
            return workflowService.listNextWorkflowStatusDto(handle.$http, handle.workflowInstance.workflowInstanceId).then(response => {
                handle.nextWorkflowStatusList = response.data
                handle.log('assigned next workflow:' + handle.nextWorkflowStatusList)
            })
        },
        loadHistory (validationResult) {
            this.workflowInstanceStatusDtoList = null
            var handle = this
            return workflowService.listWorkflowStatusInstanceDto(handle.$http, handle.workflowInstance.workflowInstanceId).then(function (response) {
                handle.workflowInstanceStatusDtoList = response.data
            })
        },
        loadWorkflowStatus (crrId) {
            this.currentWorkflowStatus = {}
            var handle = this
            return workflowService.currentWorkflowStatusDto(handle.$http, workflowService.WorkflowEnum.CulturalResourceRecording, crrId)
                .then(function (response) {
                    handle.currentWorkflowStatus = response.data
                    handle.$emit(handle.onWorkflowLoadedEventName)
                })
        },
        workflowSubmit () {
            var investigationSubmit = culturalResourceRecordingService.WorkflowStatusEnum.PendingInvestigationSubmit
            // submit only if the nextWorkflowStatusList contains "PendingInvestigationSubmit"
            if (this.currentWorkflowStatusCheck) {
                workflowService.submit(this.$http, this.workflowInstance.workflowInstanceId, investigationSubmit, null, null).then(result => {
                    if (result.data.isValid) {
                        this.log('saving workflow is valid, reloading pg')
                        this.$router.go()
                    } else {
                        this.log('saving workflow is INVALID, showing errors')
                        this.validationResult = result.data
                    }
                })
            } else {
                this.log('workflowSubmit did nothing')
            }
        },
        workflowSubmitOnSubmitSuccess (validationResult) {
            this.log(this.isDebug, this.componentName, 'workflowSubmitOnSubmitSuccess')
            this.log(this.isDebug, validationResult)

            this.log(this.isDebug, this.componentName + ' - workflowSubmitOnSubmitSuccess', 'calling loadData')
            //this.$router.go()
            this.loadData().then(response => {
                //load each site eval component
                if (this.$refs.siteEval && this.$refs.siteEval.length > 0) {
                    this.$refs.siteEval.forEach(siteEval => {
                        siteEval.loadData()
                    })
                }
            })
            this.log(this.isDebug, this.componentName + ' - workflowSubmitOnSubmitSuccess', 'emit event: ' + this.onWorkflowSubmitSuccessEventName)
            this.$emit(this.onWorkflowSubmitSuccessEventName, validationResult)
        }
    }
}
</script>



// WEBPACK FOOTER //
// SiteFormEligibility.vue?1c8d3503